import { getPaymentMethod } from 'apis/me'

/**
 * クレカ情報が登録されているか
 * @param cognitoUserId
 */
export const isCreditCardRegisterd = async (
  cognitoUserId?: string
): Promise<boolean> => {
  try {
    await getPaymentMethod()
    return true
  } catch {
    return false
  }
}

/**
 * 投稿内容の変換処理
 * メンションのテキストをAタグに変換する
 * TODO: twitter-textでメンションを抽出するようにする
 */
export const postContentConvertingForView = (content: string): string => {
  // URL内の@から始まる文字列は取得しない
  const regex = /^(?!.*http)?@[0-9a-zA-Z_]{1,20}/g 
  const mentionList = content.match(regex)
  if (mentionList != null) {
    mentionList.forEach((mention, i) => {
      // メンションの文字列を一時的に置換する
      // 正規表現にマッチするメンションが複数指定されている場合に、
      // replaceの関数が先頭のメンションのみ置換し続けるのを回避するため
      const replaceUserName = `{MENTION_USER-${i}}`
      content = content.replace(mention, replaceUserName)
    })

    mentionList.forEach((mention, i) => {
      const replaceUserName = `{MENTION_USER-${i}}`
      const userId = mention.substring(1)
      content = content.replace(
        replaceUserName,
        `<a href="/door/${userId}">${mention}</a>`
      )
    })
  }
  content = content.replace(/\n/g, '<br />')
  return content
}

export const extractHashtagsFromString = (content: string): string[] => {
  const twitterText = require('twitter-text')
  return twitterText.default.extractHashtags(content)
}

export const extractMentionsFromString = (content: string): string[] => {
  const twitterText = require('twitter-text')
  return twitterText.default.extractMentions(content)
}

export const extractUrlsFromString = (content: string): string[] => {
  const twitterText = require('twitter-text')
  return twitterText.default.extractUrls(content)
}

